<mat-card appearance="outlined" class="game-grades-card-shell">
    <mat-card-header>
        <table style="width:100%; ">
            <tbody>
                <tr>
                    <td colspan="4"
                        style="font-family: Rubik,Verdana; font-weight: bold; font-size: x-small; text-align: left;">
                        {{GamePlayerRanking.Game.DivisionName }} 
                    </td>
                </tr>
                <tr>
                    <td colspan="4" style="font-family: Rubik,Verdana; font-size: x-small; text-align: left; padding-bottom: 4px;">
                        {{GamePlayerRanking.Game.GameDate | date: 'MMM dd, yyyy'}} <!-- - {{GamePlayerRanking.Game.GameTime | date: 'HH:mm'}} -->
                    </td>
                </tr>
                <tr>
                    <td style="text-align:left;width: 32px;">
                        <a class="gamelink" [routerLink]="['/games', GamePlayerRanking.Game.GameId]" >
                            <img [src]="('../../assets/img/' + GamePlayerRanking.Game.HomeTeamSmallIcon).replace('//','/').toLowerCase()" style="height:32px;" >
                        </a>
                    </td>
                    <td>
                        <a class="gamelink" [routerLink]="['/games', GamePlayerRanking.Game.GameId]" >
                        <span class="TeamName">{{GamePlayerRanking.Game.HomeTeamName }}</span>
                        </a>
                    </td>
                    <td style="text-align: right;">
                        <a class="gamelink" [routerLink]="['/games', GamePlayerRanking.Game.GameId]" >
                            <span class="TeamName">{{GamePlayerRanking.Game.AwayTeamName }}</span>
                        </a>
                    </td>
                    <td style="text-align:center;width: 32px;"> 
                        <a class="gamelink" [routerLink]="['/games', GamePlayerRanking.Game.GameId]" >                            
                            <img [src]="('../../assets/img/' + GamePlayerRanking.Game.AwayTeamSmallIcon).replace('//','/').toLowerCase()" style="height: 32px;">
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </mat-card-header>
    <mat-card-content style="margin-bottom: 0px;">
              
        <table width="100%">
            @for(ranking of GamePlayerRanking.GamePlayerRankings; track $index) {                
                @if(ranking.NoOfBadHome + ranking.NoOfNeutralHome + ranking.NoOfGoodHome + ranking.NoOfVeryGoodHome + ranking.NoOfExcellentHome >0) {
                    <tr>
                        <td></td>
                        <td class="ScoutLabel">
                            <a (click)="openGradeDetails(GamePlayerRanking.Game.GameId, 'Home')" >
                            {{GamePlayerRanking.Game.HomeTeamName }} ({{ranking.ScoutName}})
                            </a>    
                        </td>                        
                        <td></td>
                    </tr>
                    <tr style="font-size: x-small;">
                        <td></td>
                        <td>
                            <a (click)="openGradeDetails(GamePlayerRanking.Game.GameId, 'Home')" >  
                       @for(i of [].constructor(ranking.NoOfBadHome); track $index) {
                            <div class="rankingbox-red">&NonBreakingSpace;</div>    
                       }
                       @for(i of [].constructor(ranking.NoOfNeutralHome); track $index) {
                            <div class="rankingbox-yellow">&NonBreakingSpace;</div>    
                       }
                       @for(i of [].constructor(ranking.NoOfGoodHome); track $index) {
                            <div class="rankingbox-green">&NonBreakingSpace;</div>    
                       }
                        @for(i of [].constructor(ranking.NoOfVeryGoodHome); track $index) {
                            <div class="rankingbox-lightgreen">&NonBreakingSpace;</div>    
                       }
                       @for(i of [].constructor(ranking.NoOfExcellentHome); track $index) {
                            <div class="rankingbox-blue">&NonBreakingSpace;</div>    
                       }
                       
                        &nbsp;{{ranking.AverageGradeHome}}
                            </a>    
                        </td>
                        
                    </tr>
                }
                @if(ranking.NoOfBadAway + ranking.NoOfNeutralAway + ranking.NoOfGoodAway + ranking.NoOfVeryGoodAway + ranking.NoOfExcellentAway >0) {
                    <tr>
                        <td></td>
                        <td class="ScoutLabel" style="font-size: x-small;">
                             <a (click)="openGradeDetails(GamePlayerRanking.Game.GameId, 'Away')" >  
                                {{GamePlayerRanking.Game.AwayTeamName }} ({{ranking.ScoutName}})    
                            </a>
                         </tr>
                    <tr style="font-size: x-small;">
                        <td></td>
                        <td>
                             <a (click)="openGradeDetails(GamePlayerRanking.Game.GameId, 'Away')" >  
                            @for(i of [].constructor(ranking.NoOfBadAway); track $index) {
                                    <div class="rankingbox-red">&NonBreakingSpace;</div>    
                            }
                            @for(i of [].constructor(ranking.NoOfNeutralAway); track $index) {
                                    <div class="rankingbox-yellow">&NonBreakingSpace;</div>    
                            }
                            @for(i of [].constructor(ranking.NoOfGoodAway); track $index) {
                                    <div class="rankingbox-green">&NonBreakingSpace;</div>    
                            }
                                @for(i of [].constructor(ranking.NoOfVeryGoodAway); track $index) {
                                    <div class="rankingbox-lightgreen">&NonBreakingSpace;</div>    
                            }
                            @for(i of [].constructor(ranking.NoOfExcellentAway); track $index) {
                                    <div class="rankingbox-blue">&NonBreakingSpace;</div>    
                            }
                            &nbsp;{{ranking.AverageGradeAway}}
                            </a>
                        </td>   
                    </tr>
                }
            }

        </table>
        

    </mat-card-content>

</mat-card>